module.exports = __webpack_public_path__ + "img/yijia5.5f6d96ca.jpg";